export enum ClientRequestEvent {
  EVENT_REQUEST_ITEM_SUBMITTED = 'client_request_item_submitted',
}
